import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { contributionService } from '../../services/contributionService';
import { ContributionStatusBadge } from '../../components/common/StatusBadge';
import { formatCurrency, formatDate } from '../../utils/helpers';
import LoadingSpinner from '../../components/common/LoadingSpinner';

export default function ContributionPlans() {
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['my-contribution-plans'],
    queryFn: () => contributionService.getMyPlans().then(r => r.data.data),
  });

  const { data: trustData } = useQuery({
    queryKey: ['trust-score'],
    queryFn: () => contributionService.getTrustScore().then(r => r.data.data),
  });

  const plans = data?.results || [];

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>My Savings Plans</h1>
          <p>Track your contribution plans and build your Trust Score</p>
        </div>
        <Link to="/contributions/new" className="btn btn-primary">New Plan</Link>
      </div>

      {trustData && (
        <div className="card" style={{ marginBottom: '1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: '0.7rem', color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.25rem' }}>Trust Score</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 800, fontFamily: 'Space Grotesk, sans-serif' }}>{trustData.score}<span style={{ fontSize: '0.9rem', color: 'var(--text-3)', fontWeight: 400 }}>/100</span></div>
          </div>
          <div style={{ display: 'flex', gap: '1.5rem', fontSize: '0.8rem', color: 'var(--text-2)' }}>
            <div><span style={{ fontWeight: 700, color: '#00d9a5' }}>{trustData.on_time_count}</span> on-time</div>
            <div><span style={{ fontWeight: 700, color: '#ffb84d' }}>{trustData.late_cured_count}</span> late</div>
            <div><span style={{ fontWeight: 700, color: '#ff7e8a' }}>{trustData.missed_count}</span> missed</div>
          </div>
        </div>
      )}

      {isLoading ? <LoadingSpinner /> : (
        <div className="card" style={{ padding: 0 }}>
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Goal</th>
                  <th>Target</th>
                  <th>Per Cycle</th>
                  <th>Cycle</th>
                  <th>Balance</th>
                  <th>Status</th>
                  <th>Started</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {plans.length === 0 ? (
                  <tr>
                    <td colSpan={8} style={{ textAlign: 'center', color: 'var(--text-3)', padding: '2rem' }}>
                      No savings plans yet. <Link to="/contributions/new" style={{ color: 'var(--primary)' }}>Start one →</Link>
                    </td>
                  </tr>
                ) : plans.map(plan => (
                  <tr key={plan.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/contributions/${plan.id}`)}>
                    <td style={{ fontWeight: 600 }}>{plan.goal_name}</td>
                    <td>{formatCurrency(plan.goal_amount)}</td>
                    <td>{formatCurrency(plan.contribution_amount)}</td>
                    <td style={{ textTransform: 'capitalize', fontSize: '0.875rem' }}>{plan.cycle}</td>
                    <td style={{ fontWeight: 600, color: '#00d9a5' }}>{formatCurrency(plan.balance)}</td>
                    <td><ContributionStatusBadge status={plan.status} /></td>
                    <td style={{ fontSize: '0.8rem', color: 'var(--text-2)' }}>{formatDate(plan.start_date)}</td>
                    <td onClick={e => e.stopPropagation()}>
                      <Link to={`/contributions/${plan.id}`} className="btn btn-ghost" style={{ fontSize: '0.75rem', padding: '0.3rem 0.75rem' }}>
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
